<template>
  <div class=" is-fullwidth">
    <div class="buttons">
      
        <button class="button " v-bind:class="{'is-success': row.show == true}" v-for="row in ranges" :key="row.id" @click="row.show = !row.show">{{ row.name }}</button>
      
      
    </div>
    
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Makeup Location</th>
          <th >Process</th>
          
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="8" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="8" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.makeup_location_name }}</td>
          
          
              <td >
                  <button class="button is-small is-info" @click="processOrder(order)" :disabled="working===true" v-show="order.makeup_location_id > 0">Process</button>
              </td>
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getStrabaneIncomingOrders(this.accessToken, this.order_by, 101)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             in_progress: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.in_progress = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getRanges() {
        UtilityService.getSimpleApiData(this.accessToken, "ranges").then(
               response => this.ranges = response 
            );
      },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.in_progress == 0) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getRanges();
           //this.getMakeupLocations();
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

